module.exports = __webpack_public_path__ + "media/images/common/kuchi_05-b5d6d2268015488cef253f4e2530f091.gif";